export function isEmpty(obj: any) {
    if (obj instanceof Map) {
        return obj.size === 0;
    } else if (Array.isArray(obj)) {
        return obj.length === 0;
    } else if (Number.isInteger(obj)) {
        return false;
    } else {
        return !obj || Object.keys(obj).length === 0;
    }
}

export function shiftElementUp<T>(index: number, array: T[]): T[] {
    if (index > 0 && index < array.length) {
        [array[index - 1], array[index]] = [array[index], array[index - 1]];
    }
    return array;
}

export function shiftElementDown<T>(index: number, array: T[]): T[] {
    if (index >= 0 && index < array.length - 1) {
        [array[index], array[index + 1]] = [array[index + 1], array[index]];
    }
    return array;
}

export function deleteArrayIndex<T>(index: number, array: T[]): T[] {
    if (index >= 0 && index < array.length) {
        array.splice(index, 1);
    }
    return array;
}

export function getFileListFromFiles(files: File[], existingFiles: FileList | null, acceptedTypes: string[]) {
    const dataTransfer = new DataTransfer();

    if (existingFiles && existingFiles.length) {
        for (let i = 0; i < existingFiles.length; i++) {
            dataTransfer.items.add(existingFiles[i]);
        }
    }

    files.forEach(file => {
        const isDuplicate = Array.from(dataTransfer.files).some(existingFile => existingFile.name === file.name && existingFile.size === file.size);
        if (!isDuplicate) {
            if (acceptedTypes && acceptedTypes.length) {
                if (acceptedTypes.includes(file.type)) {
                    dataTransfer.items.add(file);
                } 
            }
        }
    });

    return dataTransfer.files;
}